module.exports = __webpack_public_path__ + "img/news.331af697.jpg";